// extracted by mini-css-extract-plugin
export default {"container":"AddCardModal_container__nKLyX","label":"AddCardModal_label__Z9hyB","input":"AddCardModal_input__QZsCo","saveButton":"AddCardModal_saveButton__oXAQR"};